import React, { Component } from "react";
import { connectStore } from "redux-box";
import { module as passages } from "@st/passages";
import { module as ui } from "@st/ui";

import {
  Title,
} from "@c/activity-view/activities-list/ActivityCard/ActivityCard.styled";
import { PassageStyledDiv, PassageTitle,PassageCardContainer } from "./PassageCard.styled";
import { CardIcon, CardIconContainer } from "static/styled/custom.styled";
import Permission from "@s/permission";
import { module as onboard } from "@st/onboard";

class PassageCard extends Component {

  handleClick = () => {
    this.props.passages.setActivePassage(this.props.passageInfo)
    this.props.ui.showModal("PASSAGEDETAILSMODAL");
  };

  render() {
    const passageInfo = this.props.passageInfo;
    const { permission } = this.props.onboard;


    return (
      <PassageCardContainer onClick={this.handleClick}>
        <PassageStyledDiv secondary>
          <PassageTitle primary>{passageInfo.title}</PassageTitle>
          <Title>
            {this.props.passageInfo &&
            this.props.passageInfo.content &&
            this.props.passageInfo.content.length < 56
              ? passageInfo.content
              : passageInfo.content.slice(0, 60) + "..."}
          </Title>
        </PassageStyledDiv>
        {/* <StyledDivImage primary image={passageInfo.image}> */}
        <CardIconContainer>

            <CardIcon
              cursorPointer
              primary
              onClick={this.props.handlePublishClick}
              bg={passageInfo.is_active}
            >
              <i className="fa fa-check" />
            </CardIcon>
    
        </CardIconContainer>
        {/* </StyledDivImage> */}
      </PassageCardContainer>
    );
  }
}
export default connectStore({ passages, onboard, ui })(PassageCard);
